/**
 * Complete The Fit - Cart Related Product Recommendations
 * 
 * Features:
 * 1. Fetch related products from custom.get_the_look metafield of all cart products
 * 2. Randomly select 3 to display
 * 3. Display on page load and cart updates
 * 4. Automatically filter out products already in the cart
 */

(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    displayCount: 3,
    sectionId: 'product-recommendations-data'
  };
  
  /**
   * Main function - Update recommended products
   */
  function updateCompleteTheFit() {
    console.log('[Complete The Fit] Starting recommendations update');
    
    // Get cart data
    jQuery.getJSON('/cart.js')
      .done(function(cart) {
        console.log('[Complete The Fit] Raw cart data:', cart);
        
        if (!cart.items || cart.items.length === 0) {
          console.log('[Complete The Fit] Cart is empty');
          hideRecommendations();
          return;
        }
        
        const cartProductIds = cart.items.map(item => item.product_id);
        const cartItems = cart.items.map(item => ({
          id: item.product_id,
          handle: item.handle
        }));
        
        console.log('[Complete The Fit] Cart products:', cartItems.length);
        console.log('[Complete The Fit] Cart product IDs:', cartProductIds);
        
        // Fetch all recommendations
        fetchAllRecommendations(cartItems, cartProductIds);
      })
      .fail(function() {
        console.error('[Complete The Fit] Unable to fetch cart');
        hideRecommendations();
      });
  }
  
  /**
   * Fetch all recommended products
   */
  function fetchAllRecommendations(cartItems, cartProductIds) {
    const allRecommendations = new Map();
    let processedCount = 0;
    
    cartItems.forEach(item => {
      // Try to get recommendations from metafield
      fetchMetafieldRecommendations(item.handle, function(recommendations) {
        processedCount++;
        
        // Add to total list (deduplicate, filter cart products)
        if (recommendations && recommendations.length > 0) {
          recommendations.forEach(rec => {
            if (!cartProductIds.includes(rec.id) && !allRecommendations.has(rec.id)) {
              allRecommendations.set(rec.id, rec);
            }
          });
        }
        
        // All processing complete
        if (processedCount >= cartItems.length) {
          const recommendationsArray = Array.from(allRecommendations.values());
          console.log('[Complete The Fit] Total recommendations:', recommendationsArray.length);
          
          if (recommendationsArray.length > 0) {
            displayRandomProducts(recommendationsArray);
          } else {
            // Fallback: use Shopify Recommendations API
            console.log('[Complete The Fit] Metafield is empty, using Shopify recommendations');
            fetchShopifyRecommendations(cartItems, cartProductIds);
          }
        }
      });
    });
  }
  
  /**
   * Fetch recommendations from metafield (via Section API)
   */
  function fetchMetafieldRecommendations(productHandle, callback) {
    jQuery.ajax({
      url: `/products/${productHandle}?section_id=${CONFIG.sectionId}`,
      dataType: 'html',
      success: function(html) {
        try {
          // Extract JSON data
          const $html = jQuery('<div>').html(html);
          const scriptContent = $html.find('script[type="application/json"]').html();
          
          if (scriptContent) {
            const data = JSON.parse(scriptContent);
            callback(data.recommendations || []);
          } else {
            callback([]);
          }
        } catch (e) {
          console.error('[Complete The Fit] Parse failed:', e);
          callback([]);
        }
      },
      error: function() {
        console.warn(`[Complete The Fit] Unable to fetch section: ${productHandle}`);
        callback([]);
      }
    });
  }
  
  /**
   * Fallback: Use Shopify Recommendations API
   */
  function fetchShopifyRecommendations(cartItems, cartProductIds) {
    const allRecommendations = new Map();
    let processedCount = 0;
    
    cartItems.forEach(item => {
      jQuery.getJSON(`/recommendations/products.json?product_id=${item.id}&limit=10`)
        .done(function(response) {
          processedCount++;
          
          if (response.products) {
            response.products.forEach(rec => {
              if (!cartProductIds.includes(rec.id) && !allRecommendations.has(rec.id)) {
                allRecommendations.set(rec.id, rec);
              }
            });
          }
          
          if (processedCount >= cartItems.length) {
            const recommendationsArray = Array.from(allRecommendations.values());
            displayRandomProducts(recommendationsArray);
          }
        })
        .fail(function() {
          processedCount++;
          if (processedCount >= cartItems.length) {
            hideRecommendations();
          }
        });
    });
  }
  
  /**
   * Display random products
   */
  function displayRandomProducts(products) {
    if (products.length === 0) {
      console.log('[Complete The Fit] No products to display, hiding recommendations');
      hideRecommendations();
      return;
    }
    
    console.log('[Complete The Fit] Available product pool:', products.length, 'products');
    console.log('[Complete The Fit] Product pool:', products.map(p => `${p.title} (ID: ${p.id})`));
    
    // Shuffle randomly
    const shuffled = shuffleArray([...products]);
    const selected = shuffled.slice(0, Math.min(CONFIG.displayCount, shuffled.length));
    
    console.log('[Complete The Fit] Randomly selected 3 products:');
    selected.forEach((p, i) => {
      console.log(`  ${i + 1}. ${p.title} (ID: ${p.id})`);
    });
    
    // Render
    renderProducts(selected);
    
    // Show container
    showRecommendations();
  }
  
  /**
   * Render product HTML
   */
  function renderProducts(products) {
    let html = '';
    
    products.forEach(function(product) {
      const price = (product.price / 100).toFixed(2);
      const comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
      const img = product.featured_image || product.image || '//cdn.shopify.com/s/files/1/0000/placeholder.jpg';
      const variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
      
      html += `
        <div class="recommended-item">
          <div class="recommended-inner">
            
            <a href="${product.url}" class="recommended-title-link">
              <div class="cust_tit">
                <h2>${escapeHtml(product.title)}</h2>
                <p class="custom_price">
                  $${price}
                  ${comparePrice ? `<span class="compare_price">$${comparePrice}</span>` : ''}
                </p>
              </div>
            </a>
            
            <a href="${product.url}" class="recommended-image-link">
              <div class="image-wrap">
                <img src="${img}" alt="${escapeHtml(product.title)}" loading="lazy">
              </div>
            </a>
            
            <button class="add-recommended-btn" data-variant-id="${variantId}">
              Add <span>+</span>
            </button>
            
          </div>
        </div>
      `;
    });
    
    jQuery('.custm_recomm_title').html(html);
  }
  
  /**
   * Show recommendations section
   */
  function showRecommendations() {
    jQuery('.main_custom').show();
    
    if (jQuery(window).width() < 580) {
      jQuery('.main_mobile').show();
    } else {
      jQuery('.main_mobile').hide();
    }
  }
  
  /**
   * Hide recommendations section
   */
  function hideRecommendations() {
    console.log('[Complete The Fit] Calling hideRecommendations');
    console.trace(); // Print call stack
    jQuery('.main_custom').hide();
    jQuery('.main_mobile').hide();
    jQuery('.custm_recomm_title').html('');
  }
  
  /**
   * Utility: Shuffle array randomly
   */
  function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }
  
  /**
   * Utility: Escape HTML
   */
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  
  // ========================================
  // Event Bindings
  // ========================================
  
  /**
   * Initialize on page load
   */
  jQuery(document).ready(function() {
    console.log('[Complete The Fit] Initializing');
    
    // Update immediately
    updateCompleteTheFit();
    
    // Save last cart state
    var lastCartState = null;
    
    /**
     * Check if cart has changed
     */
    function checkCartChanges() {
      jQuery.getJSON('/cart.js')
        .done(function(cart) {
          // Create cart state snapshot
          var currentState = JSON.stringify({
            count: cart.item_count,
            ids: cart.items.map(function(item) { 
              return item.id + ':' + item.quantity; 
            }).sort()
          });
          
          // First run
          if (lastCartState === null) {
            lastCartState = currentState;
            return;
          }
          
          // Check if changed
          if (lastCartState !== currentState) {
            console.log('[Complete The Fit] Cart has changed, triggering update');
            console.log('[Complete The Fit] Old state:', lastCartState);
            console.log('[Complete The Fit] New state:', currentState);
            
            lastCartState = currentState;
            
            // Delay 500ms to ensure all data is synced
            setTimeout(function() {
              updateCompleteTheFit();
            }, 500);
          }
        })
        .fail(function() {
          console.error('[Complete The Fit] Unable to fetch cart state');
        });
    }
    
    // Check cart changes every 2 seconds
    setInterval(checkCartChanges, 2000);
    console.log('[Complete The Fit] Polling started (checking every 2 seconds)');
    
    // Backup: also listen for cart:updated event
    jQuery(document).on('cart:updated', function() {
      console.log('[Complete The Fit] Received cart:updated event');
      setTimeout(function() {
        updateCompleteTheFit();
        // Update snapshot
        jQuery.getJSON('/cart.js').done(function(cart) {
          lastCartState = JSON.stringify({
            count: cart.item_count,
            ids: cart.items.map(function(item) { 
              return item.id + ':' + item.quantity; 
            }).sort()
          });
        });
      }, 300);
    });
  });
  
  /**
   * Add to cart button click event
   * Opens Quick Add modal instead of adding directly
   */
  jQuery(document).on('click', '.add-recommended-btn', function(e) {
    e.preventDefault();
    
    const $btn = jQuery(this);
    $btn.parents('.cart-bg').addClass('addbg');

    const $item = $btn.closest('.recommended-item');
    const variantId = $btn.data('variant-id');
    
    // Get product info
    const productHandle = $item.find('a').first().attr('href');
    const productTitle = $item.find('h2').text();
    
    if (!productHandle) {
      console.error('[Complete The Fit] Unable to get product handle');
      return;
    }
    
    // Extract handle from URL
    const handle = productHandle.replace('/products/', '').split('?')[0];
    
    console.log('[Complete The Fit] Opening Quick Add:', handle);
    
    // Open Quick Add modal
    if (window.QuickAddModal) {
      window.QuickAddModal.open(handle, productTitle);
    } else {
      // Fallback: add to cart directly (if Quick Add is not loaded)
      console.warn('[Complete The Fit] Quick Add not loaded, adding to cart directly');
      addToCartDirectly($btn, variantId);
    }
  });
  
  /**
   * Add to cart directly (fallback)
   */
  function addToCartDirectly($btn, variantId) {
    if (!variantId) {
      console.error('[Complete The Fit] Missing variant ID');
      return;
    }
    
    $btn.prop('disabled', true).text('Adding...');
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1
      },
      dataType: 'json',
      success: function(item) {
        console.log('[Complete The Fit] Successfully added:', item);
        
        $btn.text('Added!').addClass('added');
        
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        
        jQuery(document).trigger('cart:updated');
        
        setTimeout(function() {
          $btn.prop('disabled', false).text('Add +').removeClass('added');
        }, 2000);
      },
      error: function(xhr) {
        console.error('[Complete The Fit] Failed to add');
        
        $btn.prop('disabled', false).text('Add +');
        
        try {
          const response = JSON.parse(xhr.responseText);
          alert(response.description || 'Failed to add to cart');
        } catch (e) {
          alert('Failed to add to cart');
        }
      }
    });
  }
  
  // Expose globally (replaces the old you_may_like function)
  window.updateCompleteTheFit = updateCompleteTheFit;
  
  console.log('[Complete The Fit] Script loaded');
  
})();